import React, { useState, useEffect } from 'react'
import { withNamespaces } from 'react-i18next'
import IconButton from '@material-ui/core/IconButton'
import stylesLogin from '../../styles/login.module.css';
import stylesHome from '../../styles/home.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/pro-duotone-svg-icons";
import { helpPage } from '../../utils/redirect';
import * as SourcePg from '../../scripts/HelpOnlineSourcePage';
import Popup from '../controls/Popup';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    divTest: {
        width: '30px',
        height: '30px'
    }
}));

function HelpOnlineButton(props) {
    const classes = useStyles();
    const [Css, setCss] = useState({});
    const [titlePop, setTitlePop] = useState(i18next.t("helpOnline:title.helpOnline"));
    const [openPop, setOpenPop] = useState(false);
    const { SourcePage } = props;

    useEffect(() => {
        if (SourcePage == SourcePg.Source_Home) {
            setCss({ div: stylesHome.divHelpOnline, icon: stylesHome.icon_helpOnline });
        } else {
            setCss({ div: stylesLogin.divHelpOnline, icon: stylesLogin.icon_helpOnline });
        }
    }, []);

    const handleOpenPopup = () => {
        helpPage();
    }

    const handleClosePop = () => {
        setOpenPop(false);
    }

    return (
        <>
            <div id="divContent"></div>
            <div className={Css.div} style={{zIndex: '1200'}}>
                <IconButton onClick={handleOpenPopup}>
                    {/*<ContactSupportIcon className={Css.icon} />*/}
                    <FontAwesomeIcon className={classes.divTest} icon={faCircleQuestion} style={{ color: 'var(--color1)' }} />
                </IconButton>
            </div>
        </>
    );
}

export default withNamespaces(['helpOnline'], { wait: true })(HelpOnlineButton);